import { flexboxInterpolations } from "@oracle/oraclejet-preact/UNSAFE_Flex";
//import { cssProps } from "@oracle/oraclejet-cssprops";
import { expect } from 'chai';

const { direction } = flexboxInterpolations;
type Obj = Record<string, unknown>;

describe("flexbox direction", () => {
  const table: [Obj, Obj][] = [
    [{}, {}],
    [{ foo: "bar" }, {}],
    // [{ direction: 'row' }, cssProps`${{ flexDirection: "row", }}`],
    // [{ direction: 'column' }, cssProps`${{ flexDirection: "column", }}`],
    // [{ foo: "bar", height: 20 }, cssProps`${{ flexDirection: "column", }}`],
  ];
  table.forEach(testParams => {
    const [input, expected]= testParams;
    it(`when ${input} returns ${expected}`, async function () {
      const actual = direction(input);
      expect(actual).to.deep.equal(expected);
    });
  })
  // test.each(table)("when %o returns %o", (input, expected) => {
  //   const actual = direction(input);
  //   expect(actual).toEqual(expected);
  // });
});
// describe("flexbox direction", () => {
//   const table: [any, any][] = [
//     [{}, {}],
//     [{ foo: "bar" }, {}],
//     [{ align: "baseline"}, cssProps`${{ alignItems: "baseline"}}`],
//     [{ align: "center"}, cssProps`${{ alignItems: "center"}}`],
//     [{ align: "start"}, cssProps`${{ alignItems: "flex-start"}}`],
//     [{ align: "end"}, cssProps`${{ alignItems: "flex-end"}}`],
//     [{ align: "inherit"}, cssProps`${{ alignItems: "inherit"}}`],
//     [{ align: "initial"}, cssProps`${{ alignItems: "initial"}}`],
//     [{ align: "stretch"}, cssProps`${{ alignItems: "stretch"}}`],
//     [{ justify: "center"}, cssProps`${{ justifyContent: "center"}}`],
//     [{ justify: "end"}, cssProps`${{ justifyContent: "flex-end"}}`],
//     [{ justify: "start"}, cssProps`${{ justifyContent: "flex-start"}}`],
//     [{ justify: "inherit"}, cssProps`${{ justifyContent: "inherit"}}`],
//     [{ justify: "initial"}, cssProps`${{ justifyContent: "initial"}}`],
//     [{ justify: "around"}, cssProps`${{ justifyContent: "space-around"}}`],
//     [{ justify: "between"}, cssProps`${{ justifyContent: "space-between"}}`],
//     [{ justify: "evenly"}, cssProps`${{ justifyContent: "space-evenly"}}`],
//     [{ wrap: "nowrap"}, cssProps`${{ flexWrap: "nowrap"}}`],
//     [{ wrap: "wrap"}, cssProps`${{ flexWrap: "wrap"}}`],
//     [{ wrap: "reverse"}, cssProps`${{ flexWrap: "wrap-reverse"}}`],
//     [{ wrap: "inherit"}, cssProps`${{ flexWrap: "inherit"}}`],
//     [{ wrap: "initial"}, cssProps`${{ flexWrap: "initial"}}`],
//   ];
//   test.each(table)("when %o returns %o", (input, expected) => {
//     const actual = direction(input);
//     expect(actual).toEqual(expected);
//   });
// });

  